import {useTranslation} from "react-i18next";
import "../styles/Termination.scss";
import backgroundRiize from "../assets/images/riize/termination_background_riize.png";
import backgroundAespa from "../assets/images/aespa/termination_background_aespa.png";
import noticeBackgroundRiize from "../assets/images/riize/termination_container_riize.png";
import noticeBackgroundAespa from "../assets/images/aespa/termination_container_aespa.png";
import titleRiizeKO from "../assets/images/riize/ko_termination_title_riize.png";
import titleRiizeEN from "../assets/images/riize/en_termination_title_riize.png";
// import titleAespaKO from "../assets/images/aespa/ko_termination_title_aespa.png";
// import titleAespaEN from "../assets/images/aespa/en_termination_title_aespa.png";
import {ARTIST, Artist, getArtistFromPath} from "../utils/artist.utils";
import {getCurrentLng} from "../utils/language.utils";

const Termination = () => {
  const {t} = useTranslation("common");
  const language = getCurrentLng();

  const artist = getArtistFromPath(window.location.pathname) as Artist;

  return (
    <div className="termination-container">
      <div className="termination-background">
        <img
          src={artist === ARTIST.aespa ? backgroundAespa : backgroundRiize}
          className="termination-background-image"
          alt=""
        />
      </div>
      <div className="termination-content">
        <div className="termination-title-wrapper">
          <img
            src={language === "en" ? titleRiizeEN : titleRiizeKO}
            className={`termination-title-image ${language === "en" ? "en" : "ko"}`}
            alt=""
          />
        </div>
        <div className={`termination-notice-wrapper ${artist}`}>
          <img
            src={
              artist === ARTIST.aespa
                ? noticeBackgroundAespa
                : noticeBackgroundRiize
            }
            className="termination-notice-background"
            alt=""
          />
          <div className={`termination-notice-content ${artist}`}>
            <div className={`termination-notice-text ${artist} notice`}>
              {t("termination.notice")}
            </div>
            <div className={`termination-notice-text ${artist} date`}>
              {t("termination.date")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termination;
